import { useEffect, useState, useMemo } from "react";
import moment from "moment";
import { useLocation, useHistory } from "react-router-dom";
import axiosClient from "../../api/axios";
import LinkUpload from "../../api/LinkUpload";
import { Spin } from "antd";

// Import CSS mới
import './CategoryView.css';

// ================= COMPONENT PHÂN TRANG (Tái sử dụng) =================
const Pagination = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    if (totalPages <= 1) return null;

    const handlePageClick = (page) => {
        if (page >= 1 && page <= totalPages) {
            onPageChange(page);
            window.scrollTo(0, 0);
        }
    };
    // ... logic render page numbers có thể giữ nguyên từ MemberView
    const renderPageNumbers = () => {
        const pageNumbers = [];
        const startPage = Math.max(1, currentPage - 1);
        const endPage = Math.min(totalPages, currentPage + 1);

        if (startPage > 1) {
            pageNumbers.push(<li key={1}><a className="page-numbers" onClick={() => handlePageClick(1)}>1</a></li>);
            if (startPage > 2) {
                pageNumbers.push(<li key="dots1"><span className="page-numbers dots">…</span></li>);
            }
        }
        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <li key={i}>
                    {i === currentPage ? (<span className="page-numbers current">{i}</span>) : (<a className="page-numbers" onClick={() => handlePageClick(i)}>{i}</a>)}
                </li>
            );
        }
        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                pageNumbers.push(<li key="dots2"><span className="page-numbers dots">…</span></li>);
            }
            pageNumbers.push(<li key={totalPages}><a className="page-numbers" onClick={() => handlePageClick(totalPages)}>{totalPages}</a></li>);
        }
        return pageNumbers;
    };

    return (
        <nav className="pagination">
            <ul>
                {currentPage > 1 && (<li><a className="prev page-numbers" onClick={() => handlePageClick(currentPage - 1)}>«</a></li>)}
                {renderPageNumbers()}
                {currentPage < totalPages && (<li><a className="next page-numbers" onClick={() => handlePageClick(currentPage + 1)}>»</a></li>)}
            </ul>
        </nav>
    );
};
// ======================================================================

const CategoryView = () => {
    const history = useHistory();
    const location = useLocation();
    const slugCategory = location.pathname.split('/category/').pop();

    const token = localStorage.getItem('token');
    const header = { Authorization: `Bearer ${token}` };

    const [category, setCategory] = useState(null);
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);

    // State cho phân trang
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 8; // 8 bài viết mỗi trang

    useEffect(() => {
        window.scrollTo(0, 0);
        setLoading(true);

        const fetchData = async () => {
            try {
                const [categoriesRes, articlesRes] = await Promise.all([
                    axiosClient.post('/Categories/GetCategoriesAll', '', { headers: header }),
                    axiosClient.post('/Articles/GetArticlesAll', '', { headers: header })
                ]);

                const currentCategory = categoriesRes.data.find(c => c.Slug === slugCategory);
                setCategory(currentCategory);

                if (currentCategory) {
                    const filteredArticles = articlesRes.data
                        .filter(a => a.IDCategory === currentCategory.ID && a.Status === 1)
                        .sort((a, b) => new Date(b.PublishDate) - new Date(a.PublishDate)); // Sắp xếp mới nhất trước
                    setArticles(filteredArticles);
                }
            } catch (error) {
                console.error("Lỗi khi tải dữ liệu:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [slugCategory]);

    // Tính toán dữ liệu cho trang hiện tại
    const currentArticlesOnPage = useMemo(() => {
        const firstItemIndex = (currentPage - 1) * itemsPerPage;
        const lastItemIndex = firstItemIndex + itemsPerPage;
        return articles.slice(firstItemIndex, lastItemIndex);
    }, [currentPage, articles]);

    if (loading) {
        return (
            <div className="container main-body" style={{ textAlign: 'center', padding: '50px' }}>
                <Spin size="large" />
            </div>
        );
    }

    if (!category) {
        return (
            <div className="container main-body" style={{ textAlign: 'center', padding: '50px' }}>
                <h2>Không tìm thấy chuyên mục.</h2>
            </div>
        );
    }

    const handleArticleClick = (slug) => {
        history.push(`/view/${slug}`);
    };

    return (
        <div className="container main-body">
            <main className="content-col">
                <section className="content-section">
                    {articles.length > 0 ? (
                        <div className="category-grid-wrapper">
                            {currentArticlesOnPage.map(item => (
                                <a
                                    href={`/view/${item.Slug}`}
                                >
                                    <article className="post-card post-card--grid" key={item.ID}>
                                        <a
                                            href={`/view/${item.Slug}`}
                                            onClick={(e) => { e.preventDefault(); handleArticleClick(item.Slug); }}
                                            className="post-card__thumb"
                                        >
                                            <img
                                                src={item.ImageUrl ? LinkUpload(item.ImageUrl) : `https://picsum.photos/500/281?random=${item.ID}`}
                                                alt={item.Title}
                                            />
                                        </a>
                                        <div className="post-card__content">
                                            <h3 className="post-card__title">
                                                <a
                                                    href={`/view/${item.Slug}`}
                                                    onClick={(e) => { e.preventDefault(); handleArticleClick(item.Slug); }}
                                                >
                                                    {item.Title}
                                                </a>
                                            </h3>
                                            <p className="post-card__summary">{item.Sumary}</p>
                                            <div className="post-card__meta">
                                                <i className="fa-regular fa-clock"></i>
                                                <span>{moment(item.PublishDate).format('DD/MM/YYYY')}</span>
                                            </div>
                                        </div>
                                    </article>
                                </a>
                            ))}
                        </div>
                    ) : (
                        <p>Chưa có bài viết nào trong chuyên mục này.</p>
                    )}
                </section>

                <Pagination
                    totalItems={articles.length}
                    itemsPerPage={itemsPerPage}
                    currentPage={currentPage}
                    onPageChange={setCurrentPage}
                />
            </main>
        </div>
    );
};

export default CategoryView;